import React, { FC } from 'react'
import { BasketType } from 'types/basket'
import { OrderTime, OrderType, SortKey, SortOrder } from 'types/checkout'
import { UserType } from 'types/user'
import { OrderCard } from 'components/Card'
import { Spacer } from 'components/Utility'
import { sortOrdersByKey } from 'lib/order'

type Props = {
  baskets: BasketType[]
  orders: OrderType[]
  orderTimes: OrderTime[]
  sortKey: SortKey
  sortOrder: SortOrder
  users: UserType[]
}

const OrderCardList: FC<Props> = (props) => {
  const { baskets, orders, orderTimes, sortKey, sortOrder, users } = props
  return (
    <div>
      {baskets
        .sort((a, b) => {
          // keyと昇順/降順に応じて受取番号の並び替えを行う（デフォルトは注文日時の降順）
          return sortOrdersByKey(sortKey, sortOrder, a, b, orders)
        })
        .map((basket) => {
          const _orders = orders.filter((order) => order.user_id === basket.user_id)
          if (_orders.length === 0) return
          const orderTime = orderTimes.find((orderTime) => orderTime.user_id === basket.user_id)
          if (!orderTime) return
          return (
            <React.Fragment key={basket.basket_number}>
              <OrderCard
                basketNumber={basket.basket_number}
                orders={_orders}
                orderTime={orderTime}
                user={users.find((user) => user.user_id === basket.user_id) ?? undefined}
              />
              <Spacer size={12} />
            </React.Fragment>
          )
        })}
    </div>
  )
}

export default OrderCardList
